export enum VerseSplitButtonSizeEnum {
  MEDIUM = 'medium',
  LARGE = 'large',
}
export enum VerseSplitButtonVariantEnum {
  PRIMARY_BLACK = 'primaryBlack',
  PRIMARY_YELLOW = 'primaryYellow',
  PRIMARY_WHITE = 'primaryWhite',
}
